
export default class VideoPlayer extends HTMLElement {
  constructor() {
    super();

    // bindings
    this.onCanPlay = this.onCanPlay.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.mediaQueryChange = this.mediaQueryChange.bind(this);

    // privates
    this._node = this;
    this._video = this._node.querySelector("video");
    this._touched = false;
    this._mobile_source = this._video.getAttribute('data-mobile');
    this._desktop_source = this._video.getAttribute('data-desktop');
    this._mql = window.matchMedia("(max-width: 768px)");

    // events
    this._video.addEventListener('canplay', this.onCanPlay);

    if ('ontouchstart' in document.documentElement) {
      document.addEventListener('touchstart', this.onTouchStart);
    }

    this._video.load();

    // VIDEO PLAYER SOURCES...
    if (this._mobile_source && this._desktop_source) {
      this._mql.addEventListener("change", this.mediaQueryChange);
      this.mediaQueryChange(this._mql);
    }
  }

  onCanPlay() {
    this._video.play();
  }

  onTouchStart() {
    if (!this._touched) {
      this._video.play();
    }

    this._touched = true;
  }

  mediaQueryChange(e) {
    if (e.matches) {
      this._video.src = this._mobile_source;
    } else {
      this._video.src = this._desktop_source;
    }

    this._video.load();
    this._video.play();
  }

  /**
   * Handle unmount.
   */
  disconnectedCallback() {
    this._video.removeEventListener('canplay', this.onCanPlay);

    if (this._mobile_source && this._desktop_source) {
      this._mql.removeEventListener("change", this.mediaQueryChange);
    }

    if ('ontouchstart' in document.documentElement) {
      document.removeEventListener('touchstart', this.onTouchStart);
    }
  }
}
